(function () {
    'use strict';

    angular.module("imApp").factory("prodGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductGroupSetting: function (parms) {
                return $ihttp.post({
                    method: 916,
                    parameters: parms || {}
                });
            },
            listProductGroups: function (parms) {
                return $ihttp.post({
                    method: 915,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
